import { css } from 'styled-components';

/** @class PropertyCardPhotoFooterMixin */
/** @method */
/**
 * Using `justify-self: flex-end` to allow as much of the photo to be clickable as
 * possible (CDS-1777)
 */
export var PropertyCardPhotoFooterMixin = /*#__PURE__*/css(["grid-area:photo-bottom;justify-self:flex-end;z-index:1;"]);